
/*
  Mumu Apparel discounted product price display.
  Only runs when the product metafield is enabled
  and the URL contains the matching discount code.

  Display-only: Shopify validates and applies
  the actual discount during checkout.
*/

(function () {
  'use strict';

  function getDiscountCode() {
  var match = document.cookie
    .split('; ')
    .find(function (cookie) {
      return cookie.startsWith('discount_code=');
    });

  if (!match) return null;

  return decodeURIComponent(
    match.substring('discount_code='.length)
  );
}

var code = getDiscountCode();

if (!code) return;

  function init(config) {
    var section = config.closest('.product-section');
    var block = config.closest('.product-block--price');

    if (!section || !block) return;

    var expected = (config.dataset.code || '').trim();
    var amount = Number(config.dataset.amount);

    if (
      !expected ||
      code !== expected ||
      !Number.isFinite(amount) ||
      amount <= 0
    ) {
      return;
    }

    var amountCents = Math.round(amount * 100);
    var variants;

    try {
      variants = JSON.parse(
        config.querySelector('[data-mumu-variants]').textContent
      );
    } catch (e) {
      return;
    }

    if (!Array.isArray(variants) || !variants.length) return;

    var regular = block.querySelector('[data-product-price]');
    var original = block.querySelector('[data-mumu-original]');
    var effective = block.querySelector('[data-mumu-effective]');
    var note = block.querySelector('[data-mumu-note]');

    if (!regular || !original || !effective || !note) return;

    var currency =
      (window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active) || 'USD';

    function money(cents) {
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          {
            style: 'currency',
            currency: currency
          }
        ).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function currentVariant() {
      var id = new URLSearchParams(
        window.location.search
      ).get('variant');

      var formSelect = section.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      );

      if (formSelect && formSelect.value) {
        id = formSelect.value;
      }

      return variants.find(function (v) {
        return String(v.id) === String(id);
      }) ||
      variants.find(function (v) {
        return v.available;
      }) ||
      variants[0];
    }

    function update() {
      var variant = currentVariant();

      if (!variant || typeof variant.price !== 'number') {
        return;
      }

      var finalCents = Math.max(
        0,
        variant.price - amountCents
      );

      original.textContent = money(variant.price);
      effective.textContent = money(finalCents);

      original.hidden = false;
      effective.hidden = false;
      note.hidden = false;

      block.classList.add('mumu-discount-active');
    }

    update();

    section.addEventListener('change', function () {
      setTimeout(update, 0);
    });

    section.addEventListener('click', function () {
      setTimeout(update, 100);
    });

    window.addEventListener('popstate', update);

    var lastVariant = null;

    var observer = new MutationObserver(function () {
      var variant = currentVariant();
      var id = variant && variant.id;

      if (id !== lastVariant) {
        lastVariant = id;
        update();
      }
    });

    observer.observe(section, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['value', 'selected']
    });
  }

  function start() {
    document.querySelectorAll(
      '[data-mumu-discount-config]'
    ).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
